import AOS from 'aos';
import Vivus from 'vivus';
import Rellax from 'rellax';

AOS.init({
	duration: 1000,
});


( function () {
	'use strict';


	var drawDuration = 150;

	var svg1 = new Vivus ('svg1', {
		duration: drawDuration,
		start: 'inViewport',
		type: 'scenario-sync',
	});

	var svg2 = new Vivus ('svg2', {
		duration: drawDuration,
		start: 'inViewport',
		type: 'scenario-sync',
	});

	var svg3 = new Vivus ('svg3', {
		duration: drawDuration,
		start: 'inViewport',
		type: 'scenario-sync',
	});

	var svg4 = new Vivus ('svg-1', {
		duration: drawDuration,
		start: 'inViewport',
		type: 'scenario-sync'
	});

	var svg5 = new Vivus ('svg-2', {
		duration: drawDuration,
		start: 'inViewport',
		type: 'scenario-sync'
	});

	var svg6 = new Vivus ('svg-3', {
		duration: drawDuration,
		start: 'inViewport',
		type: 'scenario-sync'
	});

	var animator = function(){
		svg1.play();
		svg2.play();
		svg3.play();
		svg4.play();
		svg5.play();
		svg6.play();
	}

	function fadeInNodes(step, maxStep) {
		setTimeout(function () {
			if (step < maxStep) {
				fadeInNodes(++step, maxStep)
			}
		}, 1500)
	}

	window.onload = function () {
		setTimeout(function () {
			fadeInNodes(1, 5)
		}, 1500)
	}

	new Splide( '.icons-with-map .splide', {
		mediaQuery: 'min',
		breakpoints: {
			768: {
				destroy: true,
			},
	  	}
	}).mount();


	new Splide( '.price-table .splide', {
		mediaQuery: 'min',
		breakpoints: {
			768: {
				destroy: true,
			},
		}
	}).mount();

	new Splide( '.icons .splide', {
		mediaQuery: 'min',
		breakpoints: {
			768: {
				destroy: true,
			},
		}
	}).mount();

	new Splide( '.icons-with-text .splide', {
		mediaQuery: 'min',
		breakpoints: {
			768: {
				destroy: true,
			},
		}
	}).mount();

	document.querySelector('.js-go-bottom').addEventListener('click', function(e) {
		e.preventDefault();
		let hero = document.querySelector('.hero');
		window.scrollTo({
			top: hero.offsetHeight,
			behavior: 'smooth'
		});
	});

	const videoWrapper = document.querySelector('.caption-width-video__video-wrapper');
    const video = videoWrapper.querySelector('.caption-width-video__video');
    const playButton = videoWrapper.querySelector('.caption-width-video__play-button');

    function togglePlayPause(e) {

    }

    video.addEventListener('click', function(e) {
		e.preventDefault();
		videoWrapper.classList.toggle('caption-width-video__video-wrapper--playing');
		if (video.paused) {
            video.play();
			video.setAttribute('controls', 'controls');
        } else {
            video.pause();
			video.removeAttribute('controls');
        }
	});


	window.addEventListener('scroll', function() {
		if (window.innerWidth > 992) {
		  let scroll = window.pageYOffset || document.documentElement.scrollTop;
		  let ctaSection = document.querySelector('.cta').offsetTop;

		  if (scroll > (ctaSection - 1500)) {
			let svg1 = document.querySelector('.cta__svg1');
			svg1.style.transform = `translateX(${(ctaSection - scroll) / 2}%)`;
			let svg2 = document.querySelector('.cta__svg2');
			svg2.style.transform = `translateX(${-(ctaSection - scroll) / 2}%)`;
		  }
		}
	  });

	  document.addEventListener("DOMContentLoaded", function() {
		const tabButtons = document.querySelectorAll(".caption-with-buttons__button");
		const tabContents = document.querySelectorAll(".caption-with-buttons__tab");
		tabButtons.forEach(function(button) {
		  button.addEventListener("click", function(event) {
			event.preventDefault();
			const tabId = this.getAttribute("data-tab");
			tabButtons.forEach(function(button) {
			  button.classList.remove("active");
			});
			this.classList.add("active");
			tabContents.forEach(function(tabContent) {
			  tabContent.style.display = "none";
			});
			const selectedTab = document.querySelector(`.caption-with-buttons__tab[data-tab="${tabId}"]`);
			if (selectedTab) {
			  selectedTab.style.display = "block";
			}
		  });
		});


		let hiddenImage = document.querySelector('.hide-after');
		setTimeout(function () {
			hiddenImage.classList.add('hidden');
		},1000);

	  });

} )();